import AddIcon from "@mui/icons-material/Add";
import { Link } from "@mui/material";
import { GridColDef, GridRowsProp } from "@mui/x-data-grid-pro";
import { FC } from "react";
import { useNavigate } from "react-router";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { routePaths } from "../../../Router/router";
import DataTable, { CellSize } from "../table";
import TableCellChip from "../TableCellChip/table-cell-chip";
import TableCellChipVideoResolution from "../TableCellChip/table-cell-chip-video-reolution";
import { useTranslation } from "react-i18next";

export type ContentsTableProps = {
    action?: {
        label: string;
        onClick: () => void;
    };
    rows: any[];
    hiddenColumns?: string[];
    selectedContents?: DbAssetObjectInfos[];
    setSelectedContents?: any;
};

const ContentsTable: FC<ContentsTableProps> = (props) => {
    const { t } = useTranslation();
    const { action } = props;
    const rows: GridRowsProp = props.rows;
    type Row = (typeof rows)[number];
    const { selectedContents, setSelectedContents } = props;
    const navigate = useNavigate();

    const contentDetailsColumns: GridColDef[] = [
        {
            field: "title",
            headerName: t("common:content"),
            minWidth: CellSize.xlarge,
            flex: CellSize.xlarge,
            sortable: false,
        },
        {
            field: "qualities",
            headerName: t("table:headerName.qualitiesAvailable"),
            minWidth: CellSize.large,
            flex: CellSize.large,

            sortable: false,
            renderCell: (data: Row) => TableCellChipVideoResolution({ data }),
        },
        {
            field: "audio",
            headerName: t("table:headerName.audioMixesAvailable"),
            minWidth: CellSize.large,
            flex: CellSize.large,
            sortable: false,
            renderCell: (data: Row) =>
                TableCellChip({ data: { value: data.value.flatMap((x) => x.audios.map((y) => y.lang)) } }),
        },
        {
            field: "subtitles",
            headerName: t("table:headerName.subtitlesAvailable"),
            minWidth: CellSize.large,
            flex: CellSize.large,
            sortable: false,
            renderCell: (data: Row) =>
                TableCellChip({ data: { value: data.value.flatMap((x) => x.subtitles.map((y) => y.lang)) } }),
        },
        ...(action
            ? [
                {
                    field: "order",
                    headerName: "",
                    minWidth: CellSize.medium,
                    flex: CellSize.medium,
                    sortable: false,
                    renderCell: (data: Row) => (
                        <Link component="button" color="primary.text" underline="hover" onClick={action.onClick}>
                            <AddIcon sx={{ mr: 0.5 }} fontSize="small" /> {action.label}
                        </Link>
                    ),
                },
            ]
            : []),
    ];

    return (
        <DataTable
            noControls
            selectedRows={selectedContents?.map((x) => x.id) || []}
            setSelectedRows={setSelectedContents}
            rows={rows}
            columns={contentDetailsColumns}
            rowCount={30}
            getRowHeight={() => "auto"}
            checkboxSelection={false}
            disableRowSelectionOnClick
            onRowClick={(e) => navigate(routePaths.asset.path + "/" + e.row.id + "/" + routePaths.assetHierarchy.path)}
        />
    );
};

export default ContentsTable;
